<template>
  <my-upload field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
    :width="200"
    :height="200"
    url="/api/imageResources/user"
    :params="params"
		lang-type="es-MX"
		:noRotate="false"
		:noCircle="false"
		:noSquare="true"
    :headers="headers"
    img-format="png"></my-upload>
</template>
<script>
import myUpload from 'vue-image-crop-upload';

export default {
  data() {
    return {
      show: false,
			params: {
				token: '123456798'
				, name: 'avatar'
			},
			headers: {
				"Authorization":`Bearer ${this.$store.getters.getUserToken}`
			},
			imgDataUrl: "/static/img/user_thumbnail.jpg" // the datebase64 url of created image
    }
  }
  , props:{
   
  }
  ,methods: {
    toggleShow() {
				this.show = !this.show;
			},
            /**
			 * crop success
			 *
			 * [param] imgDataUrl
			 * [param] field
			 */
			cropSuccess(imgDataUrl, field){
				console.log('-------- crop success --------');
				this.imgDataUrl = imgDataUrl;
			},
			/**
			 * upload success
			 *
			 * [param] jsonData  server api return data, already json encode
			 * [param] field
			 */
			cropUploadSuccess(jsonData, field){
				console.log('-------- upload success --------');
				console.log(jsonData);
				console.log('field: ' + field);
				let imagen = jsonData.imagen.split('.');
				this.imgDataUrl = '/api/imageResources/user/'+imagen[0]+'/'+imagen[1];
				this.$parent.usuario.foto = this.imgDataUrl;
				this.$parent.usuario.foto_miniatura = this.imgDataUrl;
			},
			/**
			 * upload fail
			 *
			 * [param] status    server api return error status, like 500
			 * [param] field
			 */
			cropUploadFail(status, field){
				console.log('-------- upload fail --------');
				console.log(status);
				console.log('field: ' + field);
			}
			, imageUploaded(){
				return this.imgDataUrl;
			}
  }
  , computed:{}
  , components: {
    'my-upload': myUpload
  }
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/seguridad/usuario/UploadImage.vue